import { render, staticRenderFns } from "./DishOrders.vue?vue&type=template&id=45777756"
import script from "./DishOrders.vue?vue&type=script&lang=js"
export * from "./DishOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports